import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { KpiCards } from "../components/dashboard/KpiCards";
import { CategoryRecap } from "../components/dashboard/CategoryRecap";
import { PoldaRecap } from "../components/dashboard/PoldaRecap";
import { SenpiRecap } from "../components/dashboard/SenpiRecap";
import { SenpiAlerts } from "../components/dashboard/SenpiAlerts";
import { CyberHero } from "../components/dashboard/CyberHero";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/dashboard").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const today = new Date().toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="space-y-8 max-w-[1400px]" data-testid="dashboard-page">
      <CyberHero user={user} today={today}>
        {data ? <KpiCards categories={data.categories} /> : <Loader2 className="h-5 w-5 animate-spin text-[#7dd3fc]" />}
      </CyberHero>
      {data && (
        <div className="cyber-scope space-y-8">
          {data.senpi_alerts?.length > 0 && (
            <SenpiAlerts rows={data.senpi_alerts} days={data.alert_days} onOpen={() => navigate("/data/senpi")} onRenewed={load} />
          )}
          <CategoryRecap categories={data.categories} onOpen={(k) => navigate(`/data/${k}`)} />
          <div className="grid gap-8 xl:grid-cols-2">
            {data.polda.length > 0 && (
              <PoldaRecap rows={data.polda} onOpen={(p) => navigate(`/data/polda_forensik?polda=${encodeURIComponent(p)}`)} />
            )}
            {data.senpi_rekap.length > 0 && <SenpiRecap rows={data.senpi_rekap} />}
          </div>
        </div>
      )}
    </div>
  );
}
